export default "__VITE_ASSET__4dafe71a__"